class IssueList {
  constructor(el, opt) {
    this.el = el;
    if ($("." + this.el).length > 0) {
      this.event();
    }
  }
  event() {
    let zIndex = 1;
    $(document).ready(function () {
        var items = $('.js-issue-list li');
        var started = false;

        gsap.registerPlugin(ScrollTrigger);

        function startAnimation() {
            if (started) return;
            started = true;

            // 最初の3つの要素にis-activeクラスを付与
            for (var i = 0; i < 2; i++) {
                items.eq(i).addClass('is-active');
            }

            // 3秒後に最初の3つの要素からis-activeクラスを1秒ごとに削除
            var windowWidth = $(window).width();
            var intervalTime = windowWidth <= 768 ? 3000 : 4000;
            for (var i = 0; i < 3; i++) {
                (function (index) {
                    setTimeout(function () {
                        items.eq(index).removeClass('is-active');
                    }, intervalTime + 2000 * index);
                })(i);
            }

            setInterval(function () {
                addRandomActiveClass();
            }, 1500);
        }

        ScrollTrigger.create({
            trigger: ".js-issue-list",
            start: "top bottom", // 要素が画面の下端に達したときにトリガー
            onEnter: startAnimation
        });

      // ランダムに要素にis-activeクラスを追加し、3秒後に削除する関数
      function addRandomActiveClass() {
            zIndex++;
            var windowWidth = $(window).width();
            var dataAttribute = windowWidth <= 768 ? 'data-overlap-mobile' : 'data-overlap-pc';
            var removeClassTime = windowWidth <= 768 ? 5000 : 8000;

            var activeOverlap = $('.js-issue-list li.is-active').map(function () {
                var overlapData = $(this).attr(dataAttribute);
                return overlapData ? overlapData.split(',') : [];
            }).get().flat();

            activeOverlap = [...new Set(activeOverlap)];

            var nonActiveItems = items.filter(function () {
                var itemOverlap = $(this).attr(dataAttribute);
                itemOverlap = itemOverlap ? itemOverlap.split(',') : [];
                return !$(this).hasClass('is-active') && !itemOverlap.some(r => activeOverlap.includes(r));
            });

            if (nonActiveItems.length > 0) {
                var randomIndex = Math.floor(Math.random() * nonActiveItems.length);
                var selectedItem = nonActiveItems.eq(randomIndex).css({'z-index': zIndex}).addClass('is-active');

                setTimeout(function () {
                    selectedItem.removeClass('is-active');
                }, removeClassTime);
            }
        }
    });
  }
}
